module.exports = __webpack_public_path__ + "img/icon-monthly-attribution.95c58b45.svg";